import React from 'react';
import { Tooltip, Icon } from '@treelab/panda';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import { InputTitle } from '../../../../Input';
import BaseInputRadio from '../InputRadio';
import { GLYPHS } from '../../../../../constants/icons';
import { TableModeType } from '../../../../../types/space';
import { IDispatch } from '../../../../../modules/stores';

type IConnectProps = ReturnType<typeof mapDispatch>;
interface IProps extends IConnectProps, WrappedComponentProps {
  lookupFieldId?: string;
  spaceId: string;
  isAvoidCollision: string;
}

const AvoidCollisionSwitch = ({
  spaceId,
  isAvoidCollision,
  updateSpace,
  intl: { formatMessage },
}: IProps) => {
  const AVOID_COLLISION_OPTIONS = [
    { name: formatMessage({ id: 'sidebar.heightBehavior.static' }), value: false },
    { name: formatMessage({ id: 'sidebar.heightBehavior.dynamic' }), value: true },
  ] as any;

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <InputTitle
          isSmall
          isReverse
          title={formatMessage({ id: 'sidebar.heightBehavior' })}
          css={'display: block;'}
        />
        <Tooltip
          placement="top-end"
          contentTitle={formatMessage({ id: 'sidebar.heightBehavior.tooltip' })}
        >
          <Icon
            icon={GLYPHS.ALERT}
            size={{ height: 16 }}
            style={{ color: 'white', marginBottom: '8px' }}
          />
        </Tooltip>
      </div>
      <BaseInputRadio
        name="isAvoidCollision"
        setFn={(val: TableModeType) =>
          updateSpace({
            id: spaceId,
            updates: {
              isAvoidCollision: val,
            },
          })
        }
        // @ts-ignore
        options={AVOID_COLLISION_OPTIONS}
        // @ts-ignore
        value={isAvoidCollision}
      />
    </>
  );
};

const mapDispatch = ({ space }: IDispatch) => ({
  updateSpace: (payload: any) => space.updateSpace(payload),
});

export default compose(
  injectIntl,
  connect(
    undefined,
    // @ts-ignore
    mapDispatch,
  ),
)(AvoidCollisionSwitch);
